
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/livestream/[slug]",
      function () {
        return require("private-next-pages/livestream/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/livestream/[slug]"])
      });
    }
  